import Joi from 'joi';

export const serviceRecordSchema = Joi.object({
  title: Joi.string().required(),
  storeable_asset_id: Joi.string().required(),
  vessel_id: Joi.string().required()
}).options({
  abortEarly: false
});
